"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevel = exports.Logger = void 0;
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["TRACE"] = 0] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARNING"] = 3] = "WARNING";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
})(LogLevel || (LogLevel = {}));
exports.LogLevel = LogLevel;
;
class Logger {
    constructor(className, level = LogLevel.INFO) {
        this.className = className;
        this.level = level;
    }
    setLevel(level) {
        this.level = level;
    }
    trace(msg, obj) { this.log(msg, LogLevel.TRACE, obj); }
    debug(msg, obj) { this.log(msg, LogLevel.DEBUG, obj); }
    info(msg, obj) { this.log(msg, LogLevel.INFO, obj); }
    warning(msg, obj) { this.log(msg, LogLevel.WARNING, obj); }
    error(msg, obj) { this.log(msg, LogLevel.ERROR, obj); }
    log(msg, level, obj) {
        if (level >= this.level) {
            let className = 'Not within class';
            if (this.className)
                className = this.className;
            const d = new Date();
            if (typeof (msg) === 'function') {
                msg = msg();
            }
            console.log('[' + className + ' ' + d.getHours() + ':' + d.getMinutes() + ' ' + d.getSeconds() + '.' + d.getMilliseconds().toString().padStart(3, '0') + ']: ' + msg);
            if (obj !== undefined) {
                console.log(obj);
            }
            if (level >= LogLevel.WARNING) {
                var err = new Error();
                console.log(err.stack);
            }
        }
        else if (this.chained !== undefined) {
            // in case another logger in the chain has a more verbose log level.
            this.chained.log(msg, level);
        }
    }
    chain(logger) {
        this.chained = logger;
    }
}
exports.Logger = Logger;
//# sourceMappingURL=logging.js.map